import React, { Component } from 'react';
import { Link } from "react-router-dom";

import config from './../config';
import FacebookSocialPlugin from './FacebookSocialPlugin';
import SkyringView from './SkyringView';
import CommentsForm from './CommentsForm';

import nyyrdiHelper from './../nyyrdiHelper';

class PageView extends Component {
	constructor(props) {
		super(props);

		this.url = config.apiRoot+'/api/pages/';

		this.state = {
			initialized: false
		};
	}

	componentDidMount() {
		if (this.props.match && this.props.match.params.sida) {
			this.fetchData();
		}
	}

	componentDidUpdate(prevProps, prevState) {
		// Athuga hvort breytur hafi breyst og hvort component eigi að uppfærast
		if (this.props.match && this.props.match.params.sida && prevProps.match.params.sida != this.props.match.params.sida) {
			if (this.state.initialized) {
				this.setState({
					initialized: false
				});

				setTimeout(function() {
					this.fetchData();
				}.bind(this), 200);
			}
			else {
				this.fetchData();
			}
		}
	}

	fetchData() {
		window.scrollTo(0, 0);

		// Sæki gögn til APA
		fetch(this.url+this.props.match.params.sida)
			.then(function(response) {
				return response.json();
			})
			.then(function(json) {
				this.setState({
					data: json
				});

				setTimeout(function() {
					this.setState({
						initialized: true
					});
				}.bind(this), 200);
			}.bind(this));
	}

	render() {
		let dataItem = this.state.data || null;

		return (
			<div className={'content-container manual-init'+(this.state.initialized ? ' initialized' : '')}>
				{
					dataItem &&
					<React.Fragment>

						<h3><span>{dataItem.title}</span></h3>

						<div className="page-content">
							<div dangerouslySetInnerHTML={{__html: dataItem.text}}/>
						</div>

					</React.Fragment>
				}
			</div>
		);
	}
}

export default PageView;



// WEBPACK FOOTER //
// ./src/components/PageView.js